export default (words, empty = '--') => {
  if (words) {
    const wordSplit = words.toUpperCase().split(' ');
    return `${wordSplit[0].charAt(0)}${wordSplit.slice(-1)[0].charAt(0)}`;
  } else {
    return empty;
  }
}
